export default {"src":"/_next/static/media/footerTopMobilePurple.962d6b4c.svg","height":158,"width":375,"blurWidth":0,"blurHeight":0};